import React, {useState, useEffect} from "react";
import {Link} from 'react-router-dom'
import { Container, Row, Button, Col } from "reactstrap";
import { getAllEvents,getAllEvents20,updateSellerCats,calcSeller} from 'network/ApiAxiosTickets'
import Header from 'components/Headers/Header';
import EventCards from "./EventCards";
import { getAll } from "network/ApiAxiosEventsGetickets";


const NewEvent = (props) => {
    const [events, setEvents] = useState(null);
    const [cartQT, setCartQT] = useState(0);
    const [allowedCategories, setallowedCategories] = useState([]);
    const [showEvents, setShowEvents] = useState(false);

    const role = JSON.parse(localStorage.getItem("user")).role
    const id = JSON.parse(localStorage.getItem("user"))._id
    const limit = JSON.parse(localStorage.getItem("user")).limit

    useEffect(() => {
        allEvents()
        getSellerCats()
        checkCartQT()
        depositCheck()
    }, []);

    const checkCartQT = ()=>{
      const cart = JSON.parse(localStorage.getItem("cart"));
      let count = 0
      if(cart){
        cart.forEach((item)=>{
          console.log(item)
        count += parseInt(item.qt)
        })
      }
      setCartQT(count)
    }

    const allEvents = async(pageNumber)=>{
        const response = await getAll(role)
        //setallowedCategories(JSON.parse(localStorage.getItem("user")).sellerCategories);
        //console.log(allowedCategories)
        setEvents(response.data.records)
        //console.log(events)
    }

    
    const getSellerCats = async()=>{
      const response = await updateSellerCats(id)
      setallowedCategories(response.data.cats)
    }
      

    const depositCheck = async()=>{
      const resp = await calcSeller(id)
      if(!resp.data.success) setShowEvents(false)

      if(resp.data.total > limit) setShowEvents(false)
      else setShowEvents(true)
    }


    return (
      <>
        {role=="admin" && <Header/>}
        <Container  className="w-auto" fluid>
          <Row className="mt--4 mb-4">
            <Col xl="2" xs="4" className="mt-7" >
               <Link to=  {'/' + role + '/events/cart'}  ><Button><i className='ni ni-cart mr-1' /> Cart {cartQT} </Button></Link>
            </Col>
            <Col xl="6" xs="4"></Col>
            <Col xl="4" xs="4" className="mt-7">
              <Link to={'/' + role + '/events/media'}><Button><i className='ni ni-album-2 mr-1' /> Media </Button></Link>
            </Col>
          </Row>
          <Row >
            
            {showEvents ? events  ? 
            events.map((item,itemIndex )=>{
                return allowedCategories.includes(item._id) && <Col key={item._id +itemIndex} className='mb-2 d-flex justify-content-center' >
                    <EventCards key={item._id +itemIndex} event={item} stateChanger={allEvents} updateCartQT={checkCartQT}/>
                </Col>
            })
            : null : <h2>You need to make a deposit before making another sale!</h2> }
            
          </Row>
        </Container>
      </>
    );
}

export default NewEvent;
